module.exports = __webpack_public_path__ + "img/download-pdf.b06da294.svg";